/* eslint-disable */
/* NOTE: This file is auto-generated. Do not edit it directly. */

import crypto from 'node:crypto'

import { PythonBridge, NDArray, ArrayLike, SparseMatrix } from '@/sklearn/types'

/**
  Binary indicators for missing values.

  Note that this component typically should not be used in a vanilla [`Pipeline`](https://scikit-learn.org/stable/modules/generated/sklearn.pipeline.Pipeline.html#sklearn.pipeline.Pipeline "sklearn.pipeline.Pipeline") consisting of transformers and a classifier, but rather could be added using a [`FeatureUnion`](https://scikit-learn.org/stable/modules/generated/sklearn.pipeline.FeatureUnion.html#sklearn.pipeline.FeatureUnion "sklearn.pipeline.FeatureUnion") or [`ColumnTransformer`](https://scikit-learn.org/stable/modules/generated/sklearn.compose.ColumnTransformer.html#sklearn.compose.ColumnTransformer "sklearn.compose.ColumnTransformer").

  Read more in the [User Guide](https://scikit-learn.org/stable/modules/generated/../impute.html#impute).

  [Python Reference](https://scikit-learn.org/stable/modules/generated/sklearn.impute.MissingIndicator.html)
 */
export class MissingIndicator {
  id: string
  opts: any

  _py: PythonBridge
  _isInitialized: boolean = false
  _isDisposed: boolean = false

  constructor(opts?: {
    /**
      The placeholder for the missing values. All occurrences of `missing_values` will be imputed. For pandas’ dataframes with nullable integer dtypes with missing values, `missing_values` should be set to `np.nan`, since `pd.NA` will be converted to `np.nan`.
     */
    missing_values?: number | string

    /**
      Whether the imputer mask should represent all or a subset of features.

      @defaultValue `'missing-only'`
     */
    features?: 'missing-only' | 'all'

    /**
      Whether the imputer mask format should be sparse or dense.

      @defaultValue `'auto'`
     */
    sparse?: boolean | 'auto'

    /**
      If `true`, [`transform`](https://scikit-learn.org/stable/modules/generated/#sklearn.impute.MissingIndicator.transform "sklearn.impute.MissingIndicator.transform") will raise an error when there are features with missing values that have no missing values in [`fit`](https://scikit-learn.org/stable/modules/generated/#sklearn.impute.MissingIndicator.fit "sklearn.impute.MissingIndicator.fit"). This is applicable only when `features='missing-only'`.

      @defaultValue `true`
     */
    error_on_new?: boolean
  }) {
    this.id = `MissingIndicator${crypto.randomUUID().split('-')[0]}`
    this.opts = opts || {}
  }

  get py(): PythonBridge {
    return this._py
  }

  set py(pythonBridge: PythonBridge) {
    this._py = pythonBridge
  }

  /**
    Initializes the underlying Python resources.

    This instance is not usable until the `Promise` returned by `init()` resolves.
   */
  async init(py: PythonBridge): Promise<void> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (this._isInitialized) {
      return
    }

    if (!py) {
      throw new Error('MissingIndicator.init requires a PythonBridge instance')
    }

    this._py = py

    await this._py.ex`
import numpy as np
from sklearn.impute import MissingIndicator
try: bridgeMissingIndicator
except NameError: bridgeMissingIndicator = {}
`

    // set up constructor params
    await this._py
      .ex`ctor_MissingIndicator = {'missing_values': ${this.opts['missing_values'] ?? undefined}, 'features': ${this.opts['features'] ?? undefined}, 'sparse': ${this.opts['sparse'] ?? undefined}, 'error_on_new': ${this.opts['error_on_new'] ?? undefined}}

ctor_MissingIndicator = {k: v for k, v in ctor_MissingIndicator.items() if v is not None}`

    await this._py
      .ex`bridgeMissingIndicator[${this.id}] = MissingIndicator(**ctor_MissingIndicator)`

    this._isInitialized = true
  }

  /**
    Disposes of the underlying Python resources.

    Once `dispose()` is called, the instance is no longer usable.
   */
  async dispose() {
    if (this._isDisposed) {
      return
    }

    if (!this._isInitialized) {
      return
    }

    await this._py.ex`del bridgeMissingIndicator[${this.id}]`

    this._isDisposed = true
  }

  /**
    Fit the transformer on `X`.
   */
  async fit(opts: {
    /**
      Input data, where `n_samples` is the number of samples and `n_features` is the number of features.
     */
    X?: ArrayLike | SparseMatrix[]

    /**
      Not used, present for API consistency by convention.
     */
    y?: any
  }): Promise<any> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error('MissingIndicator must call init() before fit()')
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_fit = {'X': np.array(${opts['X'] ?? undefined}) if ${opts['X'] !== undefined} else None, 'y': ${opts['y'] ?? undefined}}

pms_MissingIndicator_fit = {k: v for k, v in pms_MissingIndicator_fit.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_fit = bridgeMissingIndicator[${this.id}].fit(**pms_MissingIndicator_fit)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_fit.tolist() if hasattr(res_MissingIndicator_fit, 'tolist') else res_MissingIndicator_fit`
  }

  /**
    Generate missing values indicator for `X`.
   */
  async fit_transform(opts: {
    /**
      The input data to complete.
     */
    X?: ArrayLike | SparseMatrix[]

    /**
      Not used, present for API consistency by convention.
     */
    y?: any
  }): Promise<NDArray | SparseMatrix[]> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before fit_transform()'
      )
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_fit_transform = {'X': np.array(${opts['X'] ?? undefined}) if ${opts['X'] !== undefined} else None, 'y': ${opts['y'] ?? undefined}}

pms_MissingIndicator_fit_transform = {k: v for k, v in pms_MissingIndicator_fit_transform.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_fit_transform = bridgeMissingIndicator[${this.id}].fit_transform(**pms_MissingIndicator_fit_transform)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_fit_transform.tolist() if hasattr(res_MissingIndicator_fit_transform, 'tolist') else res_MissingIndicator_fit_transform`
  }

  /**
    Get output feature names for transformation.
   */
  async get_feature_names_out(opts: {
    /**
      Input features.
     */
    input_features?: any
  }): Promise<any> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before get_feature_names_out()'
      )
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_get_feature_names_out = {'input_features': ${opts['input_features'] ?? undefined}}

pms_MissingIndicator_get_feature_names_out = {k: v for k, v in pms_MissingIndicator_get_feature_names_out.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_get_feature_names_out = bridgeMissingIndicator[${this.id}].get_feature_names_out(**pms_MissingIndicator_get_feature_names_out)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_get_feature_names_out.tolist() if hasattr(res_MissingIndicator_get_feature_names_out, 'tolist') else res_MissingIndicator_get_feature_names_out`
  }

  /**
    Get metadata routing of this object.

    Please check [User Guide](https://scikit-learn.org/stable/modules/generated/../../metadata_routing.html#metadata-routing) on how the routing mechanism works.
   */
  async get_metadata_routing(opts: {
    /**
      A [`MetadataRequest`](https://scikit-learn.org/stable/modules/generated/sklearn.utils.metadata_routing.MetadataRequest.html#sklearn.utils.metadata_routing.MetadataRequest "sklearn.utils.metadata_routing.MetadataRequest") encapsulating routing information.
     */
    routing?: any
  }): Promise<any> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before get_metadata_routing()'
      )
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_get_metadata_routing = {'routing': ${opts['routing'] ?? undefined}}

pms_MissingIndicator_get_metadata_routing = {k: v for k, v in pms_MissingIndicator_get_metadata_routing.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_get_metadata_routing = bridgeMissingIndicator[${this.id}].get_metadata_routing(**pms_MissingIndicator_get_metadata_routing)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_get_metadata_routing.tolist() if hasattr(res_MissingIndicator_get_metadata_routing, 'tolist') else res_MissingIndicator_get_metadata_routing`
  }

  /**
    Set output container.

    See [Introducing the set_output API](https://scikit-learn.org/stable/modules/generated/../../auto_examples/miscellaneous/plot_set_output.html#sphx-glr-auto-examples-miscellaneous-plot-set-output-py) for an example on how to use the API.
   */
  async set_output(opts: {
    /**
      Configure output of `transform` and `fit_transform`.
     */
    transform?: 'default' | 'pandas' | 'polars'
  }): Promise<any> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error('MissingIndicator must call init() before set_output()')
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_set_output = {'transform': ${opts['transform'] ?? undefined}}

pms_MissingIndicator_set_output = {k: v for k, v in pms_MissingIndicator_set_output.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_set_output = bridgeMissingIndicator[${this.id}].set_output(**pms_MissingIndicator_set_output)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_set_output.tolist() if hasattr(res_MissingIndicator_set_output, 'tolist') else res_MissingIndicator_set_output`
  }

  /**
    Generate missing values indicator for `X`.
   */
  async transform(opts: {
    /**
      The input data to complete.
     */
    X?: ArrayLike | SparseMatrix[]
  }): Promise<NDArray | SparseMatrix[]> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error('MissingIndicator must call init() before transform()')
    }

    // set up method params
    await this._py
      .ex`pms_MissingIndicator_transform = {'X': np.array(${opts['X'] ?? undefined}) if ${opts['X'] !== undefined} else None}

pms_MissingIndicator_transform = {k: v for k, v in pms_MissingIndicator_transform.items() if v is not None}`

    // invoke method
    await this._py
      .ex`res_MissingIndicator_transform = bridgeMissingIndicator[${this.id}].transform(**pms_MissingIndicator_transform)`

    // convert the result from python to node.js
    return this
      ._py`res_MissingIndicator_transform.tolist() if hasattr(res_MissingIndicator_transform, 'tolist') else res_MissingIndicator_transform`
  }

  /**
    The features indices which will be returned when calling [`transform`](https://scikit-learn.org/stable/modules/generated/#sklearn.impute.MissingIndicator.transform "sklearn.impute.MissingIndicator.transform"). They are computed during [`fit`](https://scikit-learn.org/stable/modules/generated/#sklearn.impute.MissingIndicator.fit "sklearn.impute.MissingIndicator.fit"). If `features='all'`, `features_` is equal to `range(n_features)`.
   */
  get features_(): Promise<NDArray> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before accessing features_'
      )
    }

    return (async () => {
      // invoke accessor
      await this._py
        .ex`attr_MissingIndicator_features_ = bridgeMissingIndicator[${this.id}].features_`

      // convert the result from python to node.js
      return this
        ._py`attr_MissingIndicator_features_.tolist() if hasattr(attr_MissingIndicator_features_, 'tolist') else attr_MissingIndicator_features_`
    })()
  }

  /**
    Number of features seen during [fit](https://scikit-learn.org/stable/modules/generated/../../glossary.html#term-fit).
   */
  get n_features_in_(): Promise<number> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before accessing n_features_in_'
      )
    }

    return (async () => {
      // invoke accessor
      await this._py
        .ex`attr_MissingIndicator_n_features_in_ = bridgeMissingIndicator[${this.id}].n_features_in_`

      // convert the result from python to node.js
      return this
        ._py`attr_MissingIndicator_n_features_in_.tolist() if hasattr(attr_MissingIndicator_n_features_in_, 'tolist') else attr_MissingIndicator_n_features_in_`
    })()
  }

  /**
    Names of features seen during [fit](https://scikit-learn.org/stable/modules/generated/../../glossary.html#term-fit). Defined only when `X` has feature names that are all strings.
   */
  get feature_names_in_(): Promise<NDArray> {
    if (this._isDisposed) {
      throw new Error(
        'This MissingIndicator instance has already been disposed'
      )
    }

    if (!this._isInitialized) {
      throw new Error(
        'MissingIndicator must call init() before accessing feature_names_in_'
      )
    }

    return (async () => {
      // invoke accessor
      await this._py
        .ex`attr_MissingIndicator_feature_names_in_ = bridgeMissingIndicator[${this.id}].feature_names_in_`

      // convert the result from python to node.js
      return this
        ._py`attr_MissingIndicator_feature_names_in_.tolist() if hasattr(attr_MissingIndicator_feature_names_in_, 'tolist') else attr_MissingIndicator_feature_names_in_`
    })()
  }
}
